import axios from 'axios';
import { Dialog } from 'vant';
import Qs from 'qs';
import {Loading} from 'element-ui'
// import newhttp from './newhttp';
let loadingInstance = {};

axios.defaults.baseURL = 'http://assess.holy-sport.com:8001';
// axios.defaults.baseURL = 'http://39.100.55.139:10015';
// axios.defaults.baseURL = 'http://'+localStorage.serve_ip+':'+localStorage.serve_port+''
// D:\InformationPublish\WebAPIServerRelease\Sports\TTE
// :http:/assess.holy-sport.com:8001

//请求拦截器---即异常处理
axios.interceptors.request.use(config => {
	// console.log(config)
	// config.url = 'http://39.100.55.139:10001'+config.url;
	config.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
	// config.headers['Authorization'] = 'Token!@#2024';
	// config.headers['Access-Control-Allow-Origi'] = '*'
	config.transformRequest = [function (data) {
		// 对 data 进行任意转换处理
		return Qs.stringify(data)
        // return data
    }];
	// loadingInstance = Loading.service({
    //     lock: true,
    //     text: '正在加载,请稍后...',
    // });
	return config
 }, error => {
	// loadingInstance.close();  // 关闭加载遮罩层
	Dialog({
		message: '请求超时!',
	})

	return Promise.reject(error)
});
  
  //响应拦截器---即异常处理
  axios.interceptors.response.use(response => {
	console.log(response)
	// loadingInstance.close();  // 关闭加载遮罩层
	return response
  }, error => {
	// console.log(error)
	if (error && error.response) {
		// loadingInstance.close();  // 关闭加载遮罩层
	  switch (error.response.status) {
		case 400:
		  error.message = '错误请求'
		  break;
		case 401:
		  error.message = '未授权，请重新登录';
		//   Router.replace('/login')
		  break;
		case 403:
		  error.message = '拒绝访问'
		  break;
		case 404:
		  error.message = '请求错误,未找到该比赛相关数据'
		  break;
		case 405:
		  error.message = '请求方法未允许'
		  break;
		case 408:
		  error.message = '请求超时'
		  break;
		case 500:
		  error.message = '服务器开小差了~~'
		  break;
		case 501:
		  error.message = '网络未实现'
		  break;
		case 502:
		  error.message = '网络错误'
		  break;
		case 503:
		  error.message = '服务不可用'
		  break;
		case 504:
		  error.message = '网络超时'
		  break;
		case 505:
		  error.message = 'http版本不支持该请求'
		  break;
		default:
		  error.message = `连接错误${error.response.status}`
	  }
	} else {
	  console.log(error)
	  error.message = "连接到服务器失败"
	}
	Dialog.alert({
		message: error.message
	}).then(() => {
		// loadingInstance.close();  // 关闭加载遮罩层
	  });
	return Promise.resolve(error.response)
  })


  export default {
	// ...newhttp,
    GetFile(url){//获取文件信息
		return axios({
			method: 'GET',
			url: url,
			// responseType: 'blob',
			// transformRequest: [function (data) {
			// 	// 对 data 进行任意转换处理
			// 	return Qs.stringify(data)
			// 	// return params(data);
			// }],
			// data: {
            //     MatchID: MatchID, 
			// 	LanguageCode: sessionStorage.language,
			// }

		})
		.then(res=>{
			// console.log(res.data);
			return res.data;
		})
	},
	GetFileName(SportCode){//获取文件列表
		return axios({
			url: '/File/GetFileName?SportCode='+SportCode+'',
			method: 'GET',
			headers: {
				Authorization: 'Token!@#2024', // Token存放位置
				// 'Access-Control-Allow-Origi': '*'
			}
			// data: {
            //     SportCode: SportCode, 
			// }
			// config.headers['Authorization'] = 'Token!@#2024';
		})
		.then(res=>{
			// console.log(res.data);
			return res.data;
		})
	},
  }